import './AssignmentsByWriter.sass';

import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import _ from 'underscore';

import Spinner from '../../../../commonComponents/Spinner/Spinner';
import {
  getStatusByName,
  getStatusesForWritersFilter,
  TablesStatusFilters,
  WritersTableStatusFilters,
} from '../../../../constants/assignments';
import NumberUtils from '../../../../lib/NumberUtils';
import { canPerformAction } from '../../../../utilities/permissionUtils';
import QuestionsContainer from '../../../Questions/components/QuestionsContainer';
import ReviewHistoryContainer from '../../../ReviewHistory/components/ReviewHistoryContainer';
import Table from '../Assignemnts/Table/Table';
import AssignWriterModalContainer from './AssignWriterModal/AssignWriterModalContainer';

export default class AssignmentsByWriter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRateFilter: '',
    };
  }

  componentDidMount() {
    this.props.loadAllWriters();
  }

  // Refetches the writers list without losing the writer being reviewed, so
  // actions that do not change an assignment's status (such as a rejected
  // submission) can still refresh the comment counters.
  reloadAssignments = () => {
    this.props.loadAllWriters(this.props.selectedWriter?.email);
  };

  getWriters = (writers) => {
    let WritersObj = [];
    _.each(writers, (value) => {
      const writerData = value[0];
      if (
        !this.state.selectedRateFilter ||
        writerData.assignments.some(
          (a) =>
            a.studyProgram?.typeId?.id ===
            Number(this.state.selectedRateFilter),
        )
      ) {
        WritersObj.push(writerData);
      }
    });
    WritersObj = _.sortBy(WritersObj, 'name');
    const toReturn = [];

    _.each(WritersObj, (value) => {
      const AA_assignments = value.assignments.filter(
        (asig) => asig.status === 'Submitted',
      );
      const showAA = AA_assignments?.length > 0;
      const pdfPagesRemaining = value.assignments
        .filter(
          (assignment) =>
            assignment.status === 'Not_Started' ||
            assignment.status === 'In_Progress',
        )
        .reduce((total, assignment) => {
          const pages = Number(assignment.chapter?.pdfPages) || 0;
          return total + pages;
        }, 0);

      toReturn.push(
        <div
          key={value.id}
          className={
            this.props.selectedWriter
              ? this.props.selectedWriter.id === value.id
                ? 'writer active justify-content-between'
                : 'writer justify-content-between'
              : 'writer justify-content-between'
          }
          onClick={() => {
            this.props.selectWriter(value);
          }}
        >
          <div className="writer-content">
            <span className="writer-name">
              {value.name} {value.lastName ?? ''}
            </span>
            <div className="writer-stats">
              <span
                className="pdfPageRemaining-assignments"
                id={`pdfPageRemaining-assignments-${value.id}`}
                data-tooltip-content=""
                data-tooltip-id={`pdfPageRemaining-assignments-${value.id}-tooltip`}
              >
                {pdfPagesRemaining}
              </span>
              <div>
                {showAA && (
                  <span
                    className="AA-assignments-count"
                    id={`AA-assignments-count-${value.id}`}
                    data-tooltip-content=""
                    data-tooltip-id={`AA-assignments-count-${value.id}-tooltip`}
                  >
                    ({AA_assignments.length})
                  </span>
                )}
                {showAA && <span> / </span>}
                <span
                  className="All-assignments-count"
                  id={`All-assignments-count-${value.id}`}
                  data-tooltip-content=""
                  data-tooltip-id={`All-assignments-count-${value.id}-tooltip`}
                >
                  ({value.assignments.length})
                </span>
              </div>
            </div>
          </div>
          <ReactTooltip
            id={`pdfPageRemaining-assignments-${value.id}-tooltip`}
            place="bottom"
            variant="dark"
            className="react-tooltip"
          >
            Total PDF pages remaining (including In Progress and Not Started)
          </ReactTooltip>
          <ReactTooltip
            id={`AA-assignments-count-${value.id}-tooltip`}
            place="bottom"
            variant="dark"
            className="react-tooltip"
          >
            Total assignments awaiting approval
          </ReactTooltip>
          <ReactTooltip
            id={`All-assignments-count-${value.id}-tooltip`}
            place="bottom"
            variant="dark"
            className="react-tooltip"
          >
            Total active assignments
          </ReactTooltip>
        </div>,
      );
    });
    return toReturn;
  };

  getStatusCount(status) {
    if (this.props.selectedWriter) {
      if (status === 'Working On') {
        return _.filter(
          this.props.selectedWriter.assignments,
          (item) =>
            item.status === 'Not_Started' || item.status === 'In_Progress',
        ).length;
      }
      if (status === 'In progress') {
        return _.filter(
          this.props.selectedWriter.assignments,
          (item) => item.status === 'In_Progress',
        ).length;
      }
      if (status === 'Not Started') {
        return _.filter(
          this.props.selectedWriter.assignments,
          (item) => item.status === 'Not_Started',
        ).length;
      }
      if (status === 'Awaiting approval') {
        return _.filter(
          this.props.selectedWriter.assignments,
          (item) => item.status === 'Submitted',
        ).length;
      }
    } else {
      return 0;
    }
  }

  getAvailableRates = () => {
    const writers = this.props.writers || [];
    const ratesMap = new Map();
    _.each(writers, (value) => {
      const writerData = value[0];
      _.each(writerData?.assignments || [], (assignment) => {
        const typeId = assignment.studyProgram?.typeId;
        if (typeId && !ratesMap.has(typeId.id)) {
          ratesMap.set(typeId.id, typeId);
        }
      });
    });
    return Array.from(ratesMap.values()).sort((a, b) =>
      a.shortname.localeCompare(b.shortname),
    );
  };

  onRateFilterChange = (value) => {
    this.setState({ selectedRateFilter: value });
  };

  getQuestionComponent = () => {
    if (
      this.props.isQuestionOverview &&
      this.props.selectedAssignment.status === 'Submitted'
    ) {
      return (
        <ReviewHistoryContainer
          assignment={this.props.selectedAssignment}
          isQual={!this.props.selectedAssignment.studyProgram.type === 'qual'}
          writers
        />
      );
    }
    const reference = this.props.selectedAssignment?.chapter?.reference ?? {};
    return (
      <QuestionsContainer
        assignment={this.props.selectedAssignment}
        selectedRate={this.props.selectedAssignment.studyProgram.typeId.id}
        isQual={!this.props.selectedAssignment.studyProgram.type === 'qual'}
        reference={reference}
        writers
      />
    );
  };

  showAssignModal = () => {
    const writers = this.props.writers || [];
    const allAssignments = [];
    _.each(writers, (value) => {
      _.each(value[0].assignments, (assignment) => {
        allAssignments.push(assignment);
      });
    });
    this.props.openModal({
      modalContent: (
        <AssignWriterModalContainer
          closeModal={this.props.closeModal}
          title="Assign Writers"
          assignments={allAssignments}
          selectedWriter={this.props.selectedWriter}
          writers={writers}
          permissions={this.props.permissions}
        />
      ),
      modalClassName: 'someClass',
    });
  };

  render() {
    const writers = this.props.writers || [];
    const canAssign = canPerformAction(
      'MissionControl.Writers.Assign',
      this.props.permissions,
    );

    return (
      <div style={{ height: '100%' }}>
        {this.props.selectedAssignment ? (
          this.getQuestionComponent()
        ) : (
          <Row style={{ height: '100%' }}>
            <Col
              xs={6}
              md={3}
              ref="AssignmentList"
              className="GroupList assignmentsByWriter"
            >
              <Row className="GroupRow align-left">
                <div className="globalCountsContainer">
                  <div className="countsContainer">
                    <div className="count activeTab">Writers</div>
                  </div>
                </div>
                <div className="rateFilterRow">
                  <span className="rateFilterLabel">AFSC</span>
                  <select
                    className="form-control rateFilterSelect"
                    value={this.state.selectedRateFilter}
                    onChange={(e) => this.onRateFilterChange(e.target.value)}
                  >
                    <option value="">All AFSC</option>
                    {this.getAvailableRates().map((rate) => (
                      <option key={`rate-filter-${rate.id}`} value={rate.id}>
                        {rate.shortname}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="writers">{this.getWriters(writers)}</div>
              </Row>
            </Col>
            {!this.props.selectedWriter && (
              <Col
                md={9}
                className="d-flex align-items-center justify-content-center"
              >
                <div className="text-center">
                  Loading Writers
                  <Spinner />
                </div>
              </Col>
            )}

            {this.props.selectedWriter && (
              <Col
                md={9}
                style={{
                  flex: 1,
                  paddingTop: '15px',
                }}
                className="assignmentsTables"
              >
                {canAssign && (
                  <div className="assignmentsBtnRow">
                    <div
                      className="assignmentsBtn"
                      onClick={this.showAssignModal}
                    >
                      <div className="assignmentsBtnText">Assign</div>
                    </div>
                  </div>
                )}
                {WritersTableStatusFilters.map((filter, index) => {
                  const count = this.getStatusCount(filter);
                  const statusesForFilter = getStatusesForWritersFilter(filter);
                  return (
                    <div
                      className={index !== 0 ? 'statusTableContainer' : ''}
                      key={NumberUtils.obtainUniqueKey()}
                    >
                      <div className="filterName">{`${filter}: ${count}`}</div>
                      {count > 0 ? (
                        <Table
                          {...this.props}
                          assignments={this.props.selectedWriter.assignments.filter(
                            (assignment) =>
                              statusesForFilter.includes(assignment.status),
                          )}
                          activeStatus={filter}
                          writers
                          summary={this.props.summary}
                          setLoadingCreateGPTquestion={
                            this.props.setLoadingCreateGPTquestion
                          }
                          reloadAssignments={this.reloadAssignments}
                        />
                      ) : (
                        <div className="noAssignmentsText">
                          No assignments to show
                        </div>
                      )}
                    </div>
                  );
                })}
                <br />
              </Col>
            )}
          </Row>
        )}
      </div>
    );
  }
}
